export default __webpack_public_path__ + "static/media/360px-Sunset-Title-PMR-light-border.dc9a43e3.webp";